import { useState, useEffect } from 'react';
import { createResourceLibraryClient } from '../resourceLibraryGraphqlClient';
import { DigitalWorkoutsNavigationListQuery } from '../../scripts/graphqlQueries';
import useSessionInfo from './useSessionInfo';

const useDigitalWorkoutsNavigationList = () => {
	const { ssId } = useSessionInfo();
	const [state, setState] = useState({ items: null, hasFeatured: false });

	useEffect(() => {
		if (!ssId) return;

		createResourceLibraryClient(ssId)
			.request(DigitalWorkoutsNavigationListQuery)
			.then(data => {
				setState({
					items: data?.digitalWorkoutsNavigationList?.items ?? null,
					hasFeatured: data?.digitalWorkoutsNavigationList?.hasFeatured ?? false,
				});
			})
			.catch(err => {
				// graphql-request v4 only handles application/json; this server responds with
				// application/graphql-response+json, so the body lands in err.response.error as text
				try {
					const parsed = JSON.parse(err?.response?.error);
					const navList = parsed?.data?.digitalWorkoutsNavigationList;
					if (navList?.items) {
						setState({ items: navList.items, hasFeatured: navList.hasFeatured ?? false });
					}
				} catch {
					// keep default state — Learn tab falls back to direct navigation
				}
			});
	}, [ssId]);

	return state;
};

export default useDigitalWorkoutsNavigationList;

